/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_All_GoodInputs */

const en_us2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All good: the full workout today`)
};

const pt_br2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo certo: treino completo hoje`)
};

const es_419_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo bien: entrenamiento completo hoy`)
};

const pt_pt2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo certo: treino completo hoje`)
};

const fr_fr2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout va bien : séance complète aujourd'hui`)
};

const de_de2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles gut: heute das volle Training`)
};

const it_it2_workout_readiness_all_good = /** @type {(inputs: Workout_Readiness_All_GoodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto ok: allenamento completo oggi`)
};

/**
* | output |
* | --- |
* | "All good: the full workout today" |
*
* @param {Workout_Readiness_All_GoodInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_all_good = /** @type {((inputs?: Workout_Readiness_All_GoodInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_All_GoodInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_all_good(inputs)
	if (locale === "es-419") return es_419_workout_readiness_all_good(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_all_good(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_all_good(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_all_good(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_all_good(inputs)
	return en_us2_workout_readiness_all_good(inputs)
});
export { workout_readiness_all_good as "workout.readiness_all_good" }